/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { InviteStaffMemberMutationRequest, InviteStaffMemberMutationResponse, InviteStaffMemberPathParams, InviteStaffMember400, InviteStaffMember401, InviteStaffMember403, InviteStaffMember404, InviteStaffMember409, InviteStaffMember500 } from "../../types/staffController/InviteStaffMember.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { inviteStaffMember } from "../../client/staffController/inviteStaffMember.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const inviteStaffMemberMutationKey = () => [{ url: '/api/organizations/:organizationId/staff/invite' }] as const

export type InviteStaffMemberMutationKey = ReturnType<typeof inviteStaffMemberMutationKey>

export function inviteStaffMemberMutationOptions<TContext = unknown>(config: Partial<RequestConfig<InviteStaffMemberMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = inviteStaffMemberMutationKey()
        return mutationOptions<InviteStaffMemberMutationResponse, ResponseErrorConfig<InviteStaffMember400 | InviteStaffMember401 | InviteStaffMember403 | InviteStaffMember404 | InviteStaffMember409 | InviteStaffMember500>, {organizationId: InviteStaffMemberPathParams["organizationId"], data: InviteStaffMemberMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ organizationId, data }) => {
            return inviteStaffMember(organizationId, data, config)
          },
        })

}

/**
 * @summary Invite staff member
 * {@link /api/organizations/:organizationId/staff/invite}
 */
export function useInviteStaffMember<TContext>(options: 
{
  mutation?: UseMutationOptions<InviteStaffMemberMutationResponse, ResponseErrorConfig<InviteStaffMember400 | InviteStaffMember401 | InviteStaffMember403 | InviteStaffMember404 | InviteStaffMember409 | InviteStaffMember500>, {organizationId: InviteStaffMemberPathParams["organizationId"], data: InviteStaffMemberMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<InviteStaffMemberMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? inviteStaffMemberMutationKey()

          const baseOptions = inviteStaffMemberMutationOptions(config) as UseMutationOptions<InviteStaffMemberMutationResponse, ResponseErrorConfig<InviteStaffMember400 | InviteStaffMember401 | InviteStaffMember403 | InviteStaffMember404 | InviteStaffMember409 | InviteStaffMember500>, {organizationId: InviteStaffMemberPathParams["organizationId"], data: InviteStaffMemberMutationRequest}, TContext>
          

          return useMutation<InviteStaffMemberMutationResponse, ResponseErrorConfig<InviteStaffMember400 | InviteStaffMember401 | InviteStaffMember403 | InviteStaffMember404 | InviteStaffMember409 | InviteStaffMember500>, {organizationId: InviteStaffMemberPathParams["organizationId"], data: InviteStaffMemberMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<InviteStaffMemberMutationResponse, ResponseErrorConfig<InviteStaffMember400 | InviteStaffMember401 | InviteStaffMember403 | InviteStaffMember404 | InviteStaffMember409 | InviteStaffMember500>, {organizationId: InviteStaffMemberPathParams["organizationId"], data: InviteStaffMemberMutationRequest}, TContext>
      
}